import styled from "styled-components";

export const RoundedContainer = styled.div<{
  $includenavbar?: boolean;
  $spaceoutnavbar?: boolean;
  $background?: string;
  $centered?: boolean;
}>`
    
    max-width: min(100%, calc(100vw - var(--margin-page) - var(--margin-page-right)));
    min-width: 0;
    padding: calc( 2 * var(--margin-container) );
    padding-top: ${(p) => (p.$includenavbar ? "110px" : "initial")};
    margin: 0; 
    margin-top: ${(p) => (p.$includenavbar ? "0px" : p.$spaceoutnavbar ? "90px" : "0px")};
    margin-bottom: var(--margin-page);
    background: ${(p) => p.$background || "unset"};
    border: 2px solid var(--color-stroke);
    border-radius: 28px;

    @media (max-width: 768px) {
        padding: var(--margin-container);
        margin-top: ${(p) => (p.$spaceoutnavbar ? "55px" : "0px")};
    }

    @media (max-width: 480px) {
        padding: var(--margin-page);
    }
`;

export const FormContainer = styled(RoundedContainer)`
    h1
    {
        font-size: 48px;
        font-weight: 500;
        margin-bottom: .2em;
    }

    h2
    {
        font-size: 24px;
        font-weight: 200;
        color: var(--color-primary-desat);
        letter-spacing: -0.02em;
    }

    form
    {
        margin-left: auto;
        margin-right: auto;
        margin-top: 3em;
        font-size: 18px;
        color: var(--color-primary-dark);
        max-width: 40em;
    }

    form > fieldset
    {
        min-height: 50vh;
        text-align: center;
        margin-bottom: 16px;

        legend
        {
            padding: 0;
            font-size: 16px;
            
            button
            {
                border: none;
                background: var(--color-primary-dark);
                margin: 0;
                padding: 0;
                font-size: inherit;
                height: 1.2em;
                width: 1.2em;
                color: #fff;
                border-radius: 4px;
                margin-left: 4px;
                transition: all .25s;
            }

            button:hover
            {
                cursor: pointer;
                background-color: #000;
            }
        }

        & > legend
        {
            font-size: 24px;
            font-weight: 700;
        }

        & > fieldset
        {
            margin-bottom: 16px;
        }
    }

    fieldset, label
    {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding: 0;
        margin: 0;
        border: none;
    }

    


    form > fieldset > fieldset
    {
        border: 1px solid var(--color-primary);
        padding: 24px;
        border-radius: 16px;
        background: #fff;
    }

    form > fieldset > fieldset > legend
    {
        background-color: var(--color-primary);
        color: #fff;
        padding: 8px 16px;
        border-radius: 8px;
        margin-bottom: 0;
        font-weight: 400;
    }

    fieldset > fieldset > legend
    {
        padding-top: 16px;
        margin-bottom: 12px;
        font-weight: 700;
    }

    fieldset label
    {
        font-weight: 700;
        font-size: 16px;
        margin-bottom: 16px;
    }

    input, textarea
    {
        margin-top: 6px;
        font-size: 16px;
        border-radius: 6px;
        padding: 10px 12px;
        border: 1px solid var(--color-primary-desat);
        transition: all .25s;

        &:focus, &:active, &:focus-visible
        {
            border: 1px solid var(--color-primary-dark) !important;
        }
    }

    div.navigation
    {
        width: 100%;
        display: flex;
        flex-direction: row;
        gap: 8px;

        
    }

    button
        {
            flex: 1;
            font-size: 16px;
            padding: .75em 0;
            background-color: var(--color-primary);
            border: 1px solid var(--color-primary);
            border-radius: 8px;
            color: #fff;
            transition: all .25s;
            opacity: 1;

            &:hover:not(:disabled), &.prev:hover:not(:disabled)
            {
                cursor: pointer;
                background-color: var(--color-primary-dark);
                color: #fff;
                border-color: var(--color-primary-dark);
            }

            &:disabled
            {
                opacity: .5;
            }
        }

        button.prev
        {
            font-weight: 400;
            background: none;
            color: var(--color-primary);

            
        }

        fieldset > button
        {
            margin: 4px 0;
        }
`;

export const FeatureContainer = styled.div<{
  $rightAlign?: boolean;
  $highlightTransition?: boolean;
}>`
&&
{
    border: 1px solid var(--color-primary);
    border-radius: 28px;
    padding: 32px 48px;
    max-width: 16rem;
    transition: all .3s;
    height: 8rem;
    overflow: hidden;
    text-overflow: ellipsis;
}

&&:hover
{
    transform: ${(p) => (p.$highlightTransition ? "translateY(-10%)" : "")};
    box-shadow: 0px 8px 16px 0px rgba(64, 177, 115, 0.2);
}

div
{
    display: flex;
    justify-content: ${(p) => (p.$rightAlign ? "flex-end" : "flex-start")};
    flex-direction: ${(p) => (p.$rightAlign ? "row-reverse" : "row")};
    width: unset;
    max-width: unset;
    min-width: unset;
}

div > *
{
    flex: 1;
}

div > img
{
    width: 48px;
    height: 48px;
    margin-left: ${(p) => (p.$rightAlign ? "0" : "auto")};
    margin-right: ${(p) => (p.$rightAlign ? "32px" : "0")};
    flex: 0;
}

&& h1
{
    font-size: var(--size-main);
    font-weight: 400;
    flex: 1;
    text-align: left;
    max-width: 12ch;
}

&& p {
    font-size: var(--size-smaller);
    font-weight: 200;
    color: var(--color-primary);
    margin: 0;
    margin-top: 12px;
    text-align: left;
    line-height: normal;
    max-width: 30ch;
    width: 100%;
    line-break: auto;
}
`;
